import React from "react";

const PanoramaContext = React.createContext({});

export default PanoramaContext;
